import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import { apiRequest } from '../helpers/api';

export interface MetaData {
  title: string;
  description: string;
  url: string;
  author: string;
  date?: string;
  image?: string;
  logo?: string;
  publisher?: string;
  lang?: string;
}

export interface MetaDataState {
  metaDatas: MetaData;
  loading: boolean;
}

const initialState: MetaDataState = {
  metaDatas: {
    title: '',
    description: '',
    url: '',
    author: '',
  },
  loading: true,
};

export const fetchMetaDataOfArticle = createAsyncThunk(
  'metaDatas/fetchMetaDataOfArticle',
  async (url: string) => {
    const result = await apiRequest<MetaData>('POST', '/scraping', undefined, {
      url: url,
    });
    return result;
  },
);

const metaDataSlice = createSlice({
  name: 'metaDatas',
  initialState: initialState,
  reducers: {
    resetLoadingMetaData(state) {
      state.loading = true;
      state.metaDatas = {
        title: '',
        description: '',
        author: '',
        url: '',
        image: undefined,
      };
    },
  },
  extraReducers: (builder) => {
    builder.addCase(fetchMetaDataOfArticle.fulfilled, (state, { payload }) => {
      state.loading = false;
      state.metaDatas = payload;
    });
  },
});

export const { resetLoadingMetaData } = metaDataSlice.actions;

export default metaDataSlice.reducer;
